<template>
    <b-modal size="md" hide-footer v-model="show" title="Configuração de Perfil de Cadastro Padrão" @hidden="cancelar">
        <b-form @submit.prevent="salvar">
            <b-form-group>
                <LgFinderPagePerfil v-if="!busy" id="UsuarioFormPerfil" :prefix="prefix + title + ' > '" v-model="form.perfil"
                    @onselect="handlePerfil" label="Perfil:*" />
            </b-form-group>

            <b-form-row class="d-flex justify-content-center">
                <b-button type="submit" size="sm" pill variant="success">
                    <b-icon icon="check-circle" />
                </b-button>
                <b-button size="sm" pill variant="danger" @click="cancelar" class="ml-2">
                    <b-icon icon="x-circle" />
                </b-button>
            </b-form-row>
        </b-form>
    </b-modal>
</template>

<script>
import LgFinderPagePerfil from "@/components/Finders/LgFinderPagePerfil.vue";
import ConfiguracaoSistemaService from "@/core/api/ConfiguracaoSistemaService";
import Swal from "sweetalert2";
import ResourceService from "@/core/api/ResourceService"

export default {
    components: {
        LgFinderPagePerfil,
    },
    props: {
        configuracao: Object,
        prefix: {
            type: String,
            default: "",
        },
    },
    data() {
        return {
            busy:false,
            show: true,
            form: {
                perfil: {}
            },
            title: "Cadastro"
        };
    },
    async beforeMount() {
        this.busy = true;
        if (this.configuracao.valorPropriedade && this.configuracao.valorPropriedade != "") {
            this.form.perfil = (await new ResourceService("/api/sgu/sistemas/perfis").get(this.configuracao.valorPropriedade)).data;
        }
        this.busy = false;
    },
    methods: {
        handlePerfil(perfil) {
            this.form.perfil = perfil;
        },
        async salvar() {
            if (!this.form.perfil) {
                this.$bvToast.toast("Preencha todos os campos", {
                    title: "Erro",
                    variant: "danger",
                    solid: true,
                });
                return;
            }

            const payload = {
                id: this.configuracao.id,
                valorPropriedade: this.form.perfil.id.toString(),
            };

            try {
                await ConfiguracaoSistemaService.atualizarConfiguracao(payload);
                this.$emit("salvo");
                await Swal.fire({
                    title: "Sucesso",
                    text: "Configuração salva com sucesso!",
                    icon: "success",
                    confirmButtonText: "OK",
                });
            } catch (error) {
                this.$bvToast.toast("Erro ao salvar configuração", {
                    title: "Erro",
                    variant: "danger",
                    solid: true,
                });
            }



        },
        cancelar() {
            this.$emit("close");
        },

    },
};
</script>
